import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import axios from 'axios';
import Landing from './pages/Landing';
import GalleryPlaceholder from './pages/GalleryPlaceholder';
import EventsPlaceholder from './pages/EventsPlaceholder';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  // Test backend connection
  useEffect(() => {
    const testBackend = async () => {
      try {
        const response = await axios.get(`${API}/`);
        console.log('Backend connected:', response.data.message);
      } catch (e) {
        console.error('Backend connection error:', e);
      }
    };
    testBackend();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/gallery" element={<GalleryPlaceholder />} />
          <Route path="/events" element={<EventsPlaceholder />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;